import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble6: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-6, message, chat"><path d="M7.75 3C4.57436 3 2 5.57436 2 8.75V20.25C2 20.6642 2.33579 21 2.75 21H16.25C19.4256 21 22 18.4256 22 15.25V8.75C22 5.57436 19.4256 3 16.25 3H7.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubble6;
